import { StaffApplication } from '../../lib/types/models/staff-application/staff-application'
import { StaffApplicationStatusInput } from '../../lib/types/models/staff-application/staff-application-input'
import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function changeStaffApplicationStatus(data: IdInput<StaffApplicationStatusInput>) {
  const { id, ...rest } = data
  return restApiClient
    .url(constructApiUrl(API.candidate.changeApplicationStatus.url, { id }))
    .patch<StaffApplication, StaffApplicationStatusInput>(rest)
}
